import { gql } from "@apollo/client";

const navigation = gql`
  query navigation {
    navigation {
      title
      titleImageForMobile
      type
      page
      categories {
        title
        items {
          text
          searchQuery
          imageForMobile
        }
        mobileImageFormat
      }
      images {
        text
        image
        query
      }
    }
  }
`;
export default navigation;
